import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'eci-mfa',
    templateUrl: './mfa.component.html',
    styleUrls: ['./mfa.component.scss'],
})
export class MFAComponent implements OnInit {

    @Output() public codeSubmit = new EventEmitter<string>();
    @Output() public resendCode = new EventEmitter<void>();
    @Output() public back = new EventEmitter<void>();

    @Input()
    public set isUserLock(val: boolean) {
        this.isUserLocked = val;
        this.startTimer();
    }

    public get isUserLock(): boolean {
        return this.isUserLocked;
    }

    private isUserLocked = false;
    public mfaForm: FormGroup;
    public codes: string[] = ['', '', '', '', '', ''];
    public progress = 100; // Initial progress percentage
    public remainingTime = 30; // Initial time in seconds
    public RESEND_TIME = 30; // Time for resending code in seconds
    public LOCK_TIME = 300; // Time when account locked in seconds
    private timerInterval: any;

    private TICK_TIME = 1000; // Interval step in ms

    constructor(private fb: FormBuilder) {
    }

    ngOnInit(): void {
        this.mfaForm = this.fb.group({
            digit0: ['', [Validators.required, Validators.pattern(/\d/)]],
            digit1: ['', [Validators.required, Validators.pattern(/\d/)]],
            digit2: ['', [Validators.required, Validators.pattern(/\d/)]],
            digit3: ['', [Validators.required, Validators.pattern(/\d/)]],
            digit4: ['', [Validators.required, Validators.pattern(/\d/)]],
            digit5: ['', [Validators.required, Validators.pattern(/\d/)]],
        });
        this.startTimer();
    }

    public onInput(event: Event, index: number): void {
        const input = event.target as HTMLInputElement;
        const value = input.value;

        if (value.length === 1 && /\d/.test(value) && index < 5) {
            const nextInput = input.nextElementSibling as HTMLInputElement;
            nextInput?.focus();
        } else if (value.length === 0 && index > 0) {
            const prevInput = input.previousElementSibling as HTMLInputElement;
            prevInput?.focus();
        }
    }

    public onSubmit(): void {
        const code = Object.values(this.mfaForm.value)
            .join('');
        this.codeSubmit.emit(code);
        this.mfaForm.reset();
    }

    private startTimer(): void {
        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
        this.progress = 100;
        this.remainingTime = this.isUserLock ? this.LOCK_TIME : this.RESEND_TIME;
        const totalTime = this.isUserLock ? this.LOCK_TIME : this.RESEND_TIME;
        console.log(this.remainingTime, totalTime, this.isUserLock , this.LOCK_TIME , this.RESEND_TIME);
        const decrement = 100 / totalTime;

        this.timerInterval = setInterval(() => {
            this.remainingTime -= 1;
            this.progress -= decrement;

            if (this.remainingTime <= 0) {
                clearInterval(this.timerInterval); // Stop the timer
                this.progress = 0;
                this.remainingTime = 0;
            }
        }, this.TICK_TIME);
    }

    public resend(): void {
        this.resendCode.emit();
        if (!this.isUserLocked) {
            this.startTimer();
        }
    }

    public getTime(): string {
        const minutes = Math.floor(this.remainingTime / 60);
        const secs = this.remainingTime % 60;

        return `${minutes}:${secs.toString().padStart(2, '0')}`;
    }
}
